import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  manageCollectionsSuccess: {
    id: 'course-authoring.library-authoring.manage-collections.success',
    defaultMessage: 'Content added to collection.',
    description: 'Message to display on updating item collections',
  },
  manageCollectionsFailed: {
    id: 'course-authoring.library-authoring.manage-collections.failed',
    defaultMessage: 'Failed to add content to collection.',
    description: 'Message to display on failure of updating item collections',
  },
});

export default messages;
